// extracted by mini-css-extract-plugin
module.exports = {"formSelect":"styles_formSelect__3mokG","iconColorSize":"styles_iconColorSize__3p6by","iconSvg":"styles_iconSvg__aBH-h"};